import { css } from '@emotion/react';
import { useRouter } from 'next/router';
import React from 'react';

import { Box } from '@/box';
import { AnchorButton } from '@/ui/controls';
import { useTheme } from '@/ui/theme/hooks';
import { Text } from '@/ui/typography';

import { useMembershipServicesModeState } from '../hooks/use-membership-services-mode-state.hook';

const CONFIRM_MESSAGE =
  'Are you sure you would like to return to normal mode? You will need to follow a link from HubSpot again to book on behalf of users.';

export function MembershipServicesModeBanner() {
  const theme = useTheme();
  const router = useRouter();
  const [membershipModeActive, setMembershipModeActive] =
    useMembershipServicesModeState();

  if (!membershipModeActive) {
    return null;
  }

  return (
    <Box
      padding={16}
      css={css({
        borderBottom: theme.keylines?.border,
        position: 'sticky',
        top: 0,
        backgroundColor: theme.colors.primary200,
      })}
      textAlign="center"
    >
      <Text style="bodyCopy">
        <span css={{ fontWeight: 'bold' }}>
          {`You are currently browsing in Membership Services Mode.`}
        </span>
        <span>{` Certain rates
        will appear differently for you. `}</span>
        <AnchorButton
          onClick={() => {
            if (!window.confirm(CONFIRM_MESSAGE)) {
              return;
            }

            setMembershipModeActive(false);
            void router.reload();
          }}
        >
          {`Return to normal`}
        </AnchorButton>
      </Text>
    </Box>
  );
}
